import { ICopyPasteInjectable, CopyPastePrivateTag } from '@src/slide/application/service/copy-paste/inject/copy-paste-injectable.interface';
import { ICopyPaste } from '@src/slide/application/service/copy-paste/copy-paste.interface';
import ua, { getVersionFromUA } from '@tencent/docs-user-agent';
import wxConfigService from '@src/slide/application/service/copy-paste/inject/wx-jsapi';
import { isEditableDriveFile } from '@src/slide/infrastructure/module/dependent/runtime-environment/drive-env';
import ENV from '@src/slide/infrastructure/module/dependent/runtime-environment/enviroment';

export default class CopyPasteInjectable implements ICopyPasteInjectable {
    public registerCustomCopyPasteListeners(manager: Pick<ICopyPaste, 'clearDraggingState' | 'services'>): void {
        // do noting
    }

    public onClipboardManagerInit = (): void => {
        wxConfigService.init();
    };

    /**
     * 支持 navigator 的浏览器是 CEF 和以 Safari 为代表的Webkit浏览器
     * mobile 使用客户端剪贴板，默认支持
     * 不支持的：Firefox/QQBrowser/低于14的Safari/windowsWx 不支持 write/read 方法
     * Webkit 的 ua 不好整理，所以这里用 isNotSupportBrowser 取反
     */
    public get supportAsyncClipboardApi(): boolean {
        const oldSafari = ua.isSafari
            && (+(getVersionFromUA('Version', ua.userAgent)?.split('.')?.[0] ?? 0) < 14);
        const isNotSupportBrowser = ua.isFirefox || ua.isQQBrowser || oldSafari;
        return ua.isMobile || !isNotSupportBrowser || this.isCEFBrowser();
    }

    /**
     * QQ 环境/企微移动端/drive微信小程序 剪贴板不支持富文本，需要额外写到内存中
     */
    public get useMemoryClipboard(): boolean {
        const isQQEnvironment = ua.isQQ || ua.isQQMiniProgram;
        const isWxMiniDrive = ua.isWxMiniProgram && isEditableDriveFile();
        const isWxWork = ua.isWxWorkPrivate || ua.isWxWork;
        return isQQEnvironment || isWxMiniDrive || isWxWork;
    }

    public get isLocalEdit(): boolean {
        return ENV.IS_LOCAL_EDIT;
    }

    public get enableImageRecovery(): boolean {
        return !ENV.IS_LOCAL_EDIT;
    }

    public shouldDownloadToLocal(imageUrl: string): boolean {
        return ENV.IS_LOCAL_EDIT && (imageUrl?.startsWith('http') || imageUrl?.startsWith('tdoc'));
    }

    public shouldShowOpenClientPaste(privateTag: CopyPastePrivateTag, privateDataString: string): boolean {
        return privateTag === CopyPastePrivateTag.TcoLocalSlideData
        && !ENV.IS_LOCAL_EDIT
        && !ua.isElectronTencentDocsClient
        && privateDataString.includes('tdocs://');
    }

    public disableCopy(manager: ICopyPaste): boolean {
        return false;
    }

    // eslint-disable-next-line @typescript-eslint/class-literal-property-style
    public get currentEnvIsInPrivate(): boolean {
        return false;
    }

    public showClipboardProtection() {
        // do nothing
    }

    private isCEFBrowser(): boolean {
        return ua.isChrome
            || ua.isChromiumEdge
            || ua.isElectronTencentDocsClient
            // mac 企微 CEF
            || ua.userAgent.includes('WeComCEF')
            // windows 企微 CEF
            || ua.userAgent.includes('MailPlugin_Electron');
    }
}
